var render = function render(){var _vm=this,_c=_vm._self._c;return _c('connect-with-other-doctor-template',{attrs:{"doctor-info":_vm.doctor,"alternative-doctor-info":_vm.requestedDoctor,"locale":_vm.locale,"language-options":_vm.languageOptions},on:{"change-language":_vm.onLanguageSelect,"connect-with-other":_vm.onConnectWithOther,"stay-connected":_vm.onStayConnected,"cancel":_vm.onCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }